import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Pages.css";

const WhySeagull = () => {
  const differentiators = [
    {
      title: "Strategy-First Approach",
      description:
        "We focus on understanding your business and growth goals before offering solutions. Every recommendation is tailored, not generic.",
    },
    {
      title: "Custom Solutions",
      description:
        "No two businesses are the same. We design solutions specifically for your industry, size, and objectives, ensuring maximum impact.",
    },
    {
      title: "Data-Driven & Results-Focused",
      description:
        "All our strategies are backed by verified data, insights, and performance metrics. You'll see measurable results, not empty promises.",
    },
    {
      title: "Long-Term Growth Partner",
      description:
        "Seagull is not just a vendor — we are a strategic partner, supporting you at every stage of growth with continuous guidance and optimization.",
    },
    {
      title: "Dedicated Expert Guidance",
      description:
        "Our team of experts is available every step of the way, ensuring that your solutions are implemented efficiently and achieve real results.",
    },
  ];

  const promises = [
    "Transparent and honest communication",
    "High-quality, accurate solutions",
    "Flexible, scalable services",
    "Measurable results that grow your business",
    "Support beyond implementation",
  ];

 const testimonials = [
  {
    text: "Seagull helped us increase qualified leads by 50% in just three months. Their approach is strategic, data-driven, and results-focused.",
    author: "Michael Thompson",
    role: "Head of Marketing",
    company: "US-based SaaS Company",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    text: "The Seagull team understood our challenges and built custom solutions that truly made a difference in our business growth.",
    author: "Emma Richardson",
    role: "Growth Director",
    company: "B2B Consulting Firm",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
  },
];



  return (
    <main>
      <Helmet>
        <title>Why Choose Seagull Partners | Trusted B2B Experts</title>
        <meta
          name="description"
          content="Discover why Seagull Partners is trusted for B2B growth: strategy-first guidance, verified data, custom solutions, and measurable results for your industry."
        />
      </Helmet>

      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Why Choose Seagull?</h1>
          <p className="page-hero-subtitle">
            We don't just provide services — we partner with businesses to
            create custom, data-driven, and results-focused solutions that drive
            measurable growth.
          </p>
          <Link to="/contact" className="btn">
            📩 Speak to Our Experts
          </Link>
        </div>
      </section>

      {/* Differentiators */}
      <section className="section">
        <div className="container">
          <div className="content-section">
            <h2 className="section-title">What Makes Us Different</h2>

            <div className="differentiators-grid">
              {differentiators.map((item, index) => (
                <div key={index} className="differentiator-card">
                  <div className="differentiator-header">
                    <span className="differentiator-icon">🔹</span>
                    <h3>
                      {index + 1}. {item.title}
                    </h3>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Our Promise */}
      <section className="section promise-section">
        <div className="container">
          <div className="content-section">
            <h2 className="section-title">Our Commitment to You</h2>

            <div className="promise-list">
              {promises.map((promise, index) => (
                <div key={index} className="promise-item">
                  <span className="promise-marker">-</span>
                  <span className="promise-text">{promise}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="section testimonials-section">
  <div className="container">
    <div className="content-section">
      <h2 className="section-title">Proven Results with Our Clients</h2>

      <div className="testimonials-grid">
        {testimonials.map((testimonial, index) => (
          <div
            key={index}
            className="testimonial-card animate-fade-up"
            style={{ animationDelay: `${index * 0.2}s` }}
          >
            <div className="testimonial-client">
              <img
                src={testimonial.image}
                alt={testimonial.author}
                className="client-image"
              />
            </div>

            <p className="testimonial-text">
              “{testimonial.text}”
            </p>

            <div className="testimonial-author">
              <strong>{testimonial.author}</strong>
              <span>{testimonial.role}</span>
              <small>{testimonial.company}</small>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

    </main>
  );
};

export default WhySeagull;
